/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MediaLinkDto,
  MediaStatusDto,
  MediaUploadTicketDto,
  PresignUploadCommand,
  ProblemDetails,
  ValidationProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const postApiV1MediaPresign = (
    presignUploadCommand: PresignUploadCommand,
 signal?: AbortSignal
) => {
      
      
      return request<MediaUploadTicketDto>(
      {url: `/api/v1/media/presign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: presignUploadCommand, signal
    },
      );
    }
  


export const getPostApiV1MediaPresignMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaPresign>>, TError,{data: PresignUploadCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaPresign>>, TError,{data: PresignUploadCommand}, TContext> => {

const mutationKey = ['postApiV1MediaPresign'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MediaPresign>>, {data: PresignUploadCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MediaPresign(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MediaPresignMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MediaPresign>>>
    export type PostApiV1MediaPresignMutationBody = PresignUploadCommand
    export type PostApiV1MediaPresignMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MediaPresign = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaPresign>>, TError,{data: PresignUploadCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MediaPresign>>,
        TError,
        {data: PresignUploadCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1MediaPresignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MediaMediaIdConfirm = (
    mediaId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MediaStatusDto>(
      {url: `/api/v1/media/${mediaId}/confirm`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MediaMediaIdConfirmMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>, TError,{mediaId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>, TError,{mediaId: string}, TContext> => {

const mutationKey = ['postApiV1MediaMediaIdConfirm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>, {mediaId: string}> = (props) => {
          const {mediaId} = props ?? {};

          return  postApiV1MediaMediaIdConfirm(mediaId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MediaMediaIdConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>>
    
    export type PostApiV1MediaMediaIdConfirmMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MediaMediaIdConfirm = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>, TError,{mediaId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MediaMediaIdConfirm>>,
        TError,
        {mediaId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MediaMediaIdConfirmMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1MediaMediaIdLink = (
    mediaId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MediaLinkDto>(
      {url: `/api/v1/media/${mediaId}/link`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MediaMediaIdLinkQueryKey = (mediaId?: string,) => {
    return [
    `/api/v1/media/${mediaId}/link`
    ] as const;
    }

    
export const getGetApiV1MediaMediaIdLinkQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError = ProblemDetails>(mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MediaMediaIdLinkQueryKey(mediaId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>> = ({ signal }) => getApiV1MediaMediaIdLink(mediaId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mediaId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MediaMediaIdLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>>
export type GetApiV1MediaMediaIdLinkQueryError = ProblemDetails


export function useGetApiV1MediaMediaIdLink<TData = Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError = ProblemDetails>(
 mediaId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MediaMediaIdLink<TData = Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError = ProblemDetails>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MediaMediaIdLink<TData = Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError = ProblemDetails>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MediaMediaIdLink<TData = Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError = ProblemDetails>(
 mediaId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MediaMediaIdLink>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MediaMediaIdLinkQueryOptions(mediaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




